import type { Booking } from "@/mocks/admin/bookings";

type Props = {
  booking: Booking;
  onClick: () => void;
};

export default function BookingCard({ booking, onClick }: Props) {
  return (
    <button
      onClick={onClick}
      className="text-left bg-white border border-ink-100 hover:border-ink-300 rounded-lg p-3.5 transition-all cursor-pointer w-full group"
    >
      <div className="flex items-center justify-between mb-2.5">
        <span className="font-mono text-[10px] font-bold text-ink-400">{booking.id}</span>
        <span className="text-[10px] text-ink-400">{booking.submittedAt}</span>
      </div>

      <div className="flex items-center gap-2.5 mb-2.5">
        <div
          className={`w-9 h-9 rounded-full ${booking.color} text-white text-xs font-bold flex items-center justify-center shrink-0`}
        >
          {booking.initials}
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-ink-900 truncate group-hover:text-brand-700">
            {booking.customer}
          </div>
          <div className="text-[11px] text-ink-500 truncate">{booking.moveType}</div>
        </div>
      </div>

      <div className="space-y-1.5 mb-3 text-[11px] text-ink-500">
        <div className="flex items-center gap-1.5">
          <i className="ri-calendar-line text-ink-400"></i>
          <span className="font-semibold text-ink-700">{booking.preferredDate}</span>
          <span className="text-ink-400">·</span>
          <span>{booking.preferredTime}</span>
        </div>
        <div className="flex items-center gap-1.5">
          <i className="ri-map-pin-line text-ink-400"></i>
          <span className="truncate">
            {booking.fromCity} <span className="text-ink-300">→</span> {booking.toCity}
          </span>
        </div>
      </div>

      <div className="flex items-center justify-between pt-2.5 border-t border-ink-100">
        <span className="text-[10px] font-semibold text-ink-500 bg-cream-100 px-2 py-0.5 rounded-full">
          {booking.source}
        </span>
        {booking.estimatedQuote ? (
          <div className="text-right">
            <div className="text-sm font-bold text-ink-900 tabular-nums">
              ${booking.estimatedQuote.toLocaleString()}
            </div>
            <div
              className={`text-[10px] font-semibold ${
                booking.depositPaid ? "text-emerald-600" : "text-amber-600"
              }`}
            >
              {booking.depositPaid ? "Deposit paid" : "Deposit pending"}
            </div>
          </div>
        ) : (
          <span className="text-[10px] font-bold text-amber-700 bg-amber-50 px-2 py-0.5 rounded-full">
            Needs Quote
          </span>
        )}
      </div>
    </button>
  );
}